import { useEffect, useRef } from "react";
import buttonStyles from "../../../styles/button.module.css";
import { buttonSizeType } from "../../../types/common";
import { updateIconColor, getIconButtonSize } from "../../../utils/buttonUtil";

export default function IconButton({
  classes,
  disable,
  onClick,
  icon,
  iconColor,
  size,
  disableClick,
  buttonBgColor
}: {
  classes?: string;
  disable?: boolean;
  icon: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | (() => void); // accepts any function regardless of its parameters.
  iconColor?: string;
  size?: buttonSizeType;
  disableClick?: boolean;
  buttonBgColor?: string;
}) {
  const iconButton = useRef(null);

  useEffect(() => {
    if (iconButton.current) updateIconColor(iconButton.current, iconColor);
  }, [iconButton, iconColor]);

  return (
    <button
      ref={iconButton}
      className={`${buttonStyles.iconButton}
      ${getIconButtonSize(size)}
      ${disableClick ? buttonStyles.hoverIcon : ""}
      ${classes || ""}`}
      style={{
        backgroundColor: buttonBgColor ? buttonBgColor : ""
      }}
      onClick={onClick}
      disabled={disable}
    >
      {icon}
    </button>
  );
}
